import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Cookies from 'js-cookie';

import { AUTH_TOKENS, AUTH_TOKEN_POOLING_INTERVAL } from 'config/app-config';
import {
  setData,
  setLoggedOut,
  setLoggedIn,
  setInitialState as resetAuthentication
} from 'state/authentication/authentication-slice';

export const getTokenData = (token) => {
  if (!token) {
    return;
  }

  try {
    return JSON.parse(window.atob(token.split('.')[1]));
  } catch {
    return;
  }
};

export const useAuthentication = (
  poolingInterval = AUTH_TOKEN_POOLING_INTERVAL
) => {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const dispatch = useDispatch();
  let nepToken = Cookies.get(AUTH_TOKENS.NEP);
  let uuaToken = Cookies.get(AUTH_TOKENS.UUA);
  let nepTokenData = getTokenData(nepToken);
  let uuaTokenData = getTokenData(uuaToken);

  const poolTokens = () => {
    nepToken = Cookies.get(AUTH_TOKENS.NEP);
    uuaToken = Cookies.get(AUTH_TOKENS.UUA);
    nepTokenData = getTokenData(nepToken);
    uuaTokenData = getTokenData(uuaToken);
    const hasTokens = !!(nepToken && uuaToken);

    setIsLoggedIn(hasTokens);
  };

  useEffect(() => {
    const timerId = setInterval(poolTokens, poolingInterval);

    poolTokens();

    return () => {
      clearInterval(timerId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // we don't want to flod redux with dispatched actions with same data
    // dispatch actions only when logged in state changes
    if (isLoggedIn) {
      dispatch(setLoggedIn());
      dispatch(
        setData({
          nepToken: nepTokenData,
          uuaToken: uuaTokenData
        })
      );
    }

    //don't trigger for initial state === null
    if (isLoggedIn === false) {
      dispatch(setLoggedOut());
      dispatch(resetAuthentication());
    }
  }, [isLoggedIn, dispatch, nepTokenData, uuaTokenData]);
};
